import { createStore, select, setProp, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import dayjs from 'dayjs';
import { todayWithTolerance } from '../day/today-with-tolerance';
import { JournalingMonthlyStreak, JournalingStreak } from './journaling-streak';
import { JournalingStreakViewModel } from './journaling-streak-view-model';

interface StatisticsProps {
  streaks: JournalingStreak[];
  streaksMonthly: JournalingMonthlyStreak[];
}

const statisticsStore = createStore(
  { name: 'statistics' },
  withProps<StatisticsProps>({ streaks: [], streaksMonthly: [] }),
);

@Injectable({ providedIn: 'root' })
export class SupaStatisticsRepository {
  streaks$ = statisticsStore.pipe(select((store) => store.streaks));
  streaksMonthly$ = statisticsStore.pipe(select((store) => store.streaksMonthly));

  currentStreak$: Observable<JournalingStreakViewModel> = this.streaks$.pipe(
    map((streaks) => {
      const currentStreak = streaks.find((streak) =>
        dayjs(streak.end_at).isAfter(dayjs().subtract(2, 'days'), 'days'),
      );
      return {
        daysCount: currentStreak?.days_count || 0,
        todayIncluded:
          !!currentStreak &&
          dayjs(currentStreak.end_at).isSame(todayWithTolerance(), 'day'),
        startAt: currentStreak?.start_at,
        endAt: currentStreak?.end_at,
      };
    }),
  );

  currentMonthlyStreak$: Observable<JournalingMonthlyStreak> = this.streaksMonthly$.pipe(
    map((streaks) => {
      const currentMonth = streaks.find((streak) =>
        dayjs(streak.month).isSame(dayjs(), 'month'),
      );
      return currentMonth as JournalingMonthlyStreak;
    }),
  );

  setStreaks(streaks: JournalingStreak[]) {
    statisticsStore.update(setProp('streaks', streaks));
  }

  setMonthlyStreaks(streaks: JournalingMonthlyStreak[]) {
    statisticsStore.update(setProp('streaksMonthly', streaks));
  }
}
